import { render, staticRenderFns } from "./bookingShipperFormatAddress.vue?vue&type=template&id=3033572a&scoped=true&"
import script from "./bookingShipperFormatAddress.vue?vue&type=script&lang=js&"
export * from "./bookingShipperFormatAddress.vue?vue&type=script&lang=js&"
import style0 from "./bookingShipperFormatAddress.vue?vue&type=style&index=0&id=3033572a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3033572a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3033572a')) {
      api.createRecord('3033572a', component.options)
    } else {
      api.reload('3033572a', component.options)
    }
    module.hot.accept("./bookingShipperFormatAddress.vue?vue&type=template&id=3033572a&scoped=true&", function () {
      api.rerender('3033572a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/bookingShipperFormatAddress.vue"
export default component.exports